import React, { useState, useMemo } from "react";
import { useDispatch } from "react-redux";

import { push } from "connected-react-router";

// import { Button } from "antd"
import { Card, Input } from "antd";

import { Pie } from "@ant-design/charts";

import L from "leaflet";

import { MapContainer, TileLayer, Marker, Tooltip } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-markercluster";

import { chain, isEqual } from "lodash";

const { Search } = Input;

function selectMap(type) {
  switch (type) {
    case "United States":
      return {
        zoom: 5,
        center: [36.2115201, -113.7164387],
      };

    case "Canada":
      return {
        zoom: 5,
        center: [-15, 24],
      };
    case "Europe":
      return {
        zoom: 5,
        center: [24.1474343, 48.0988048],
      };
    case "Asia":
      return {
        zoom: 5,
        center: [70, 23.6906011],
      };
    default:
      return {
        zoom: 2.4,
        center: [33.3861128, -3.1831302],
      };
  }
}

function TooltipCircle(props) {
  const { name, coordinates, customer, location } = props;

  const dispatch = useDispatch();
  const eventHandlers = useMemo(
    () => ({
      click() {
        dispatch(push(`/${name}/summary`));
      },
    }),
    []
  );

  return (
    <Marker
      eventHandlers={eventHandlers}
      position={coordinates}
      icon={L.divIcon({
        html: "<div><span></span></div>",
        className: "marker-cluster-small",
        iconSize: L.point(40, 40, true),
      })}
    >
      <Tooltip>
        {name} <br /> {customer} <br /> {location}
      </Tooltip>
    </Marker>
  );
}

function WorldMap(props) {
  const { robots = [] } = props;
  const [mapType, setMapType] = useState("All");

  return (
    <>
      {/* <Button onClick={() => setMapType("All")}>World</Button>
      <Button onClick={() => setMapType("Canada")}>Canada</Button>
      <Button onClick={() => setMapType("United States")}>US</Button>
      <Button onClick={() => setMapType("Europe")}>Europe</Button>
      <Button onClick={() => setMapType("Asia")}>Asia</Button> */}

      <MapContainer
        className="marker-cluster-map"
        minZoom={2}
        maxZoom={8}
        scrollWheelZoom={false}
        {...selectMap(mapType)}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution=""
        />

        <MarkerClusterGroup
          iconCreateFunction={(cluster) => {
            const childCount = cluster.getChildCount();
            let c = " marker-cluster-small";
            // if (childCount < 2) {
            //   c += "small";
            // } else if (childCount < 3) {
            //   c += "medium";
            // } else {
            //   c += "large";
            // }
            return L.divIcon({
              html: "<div><span>" + childCount + "</span></div>",
              className: "marker-cluster" + c,
              iconSize: L.point(40, 40, true),
            });
          }}
        >
          {robots.map(
            ({ name, customer, location, coordinates, country }) =>
              (mapType === "All" ||
                mapType === country ||
                (mapType === "Asia" &&
                  (country === "China" ||
                    country === "United Arab Emirates")) ||
                (mapType === "Europe" && country === "Germany")) &&
              coordinates && (
                <TooltipCircle
                  key={name}
                  name={name}
                  coordinates={coordinates}
                  customer={customer}
                  location={location}
                />
              )
          )}
        </MarkerClusterGroup>
      </MapContainer>
    </>
  );
}

function DistributionChart(props) {
  const { robots = [] } = props;

  const data = chain(robots)
    .map((item) => {
      return {
        country: item.country,
        value: robots.filter((i) => {
          return item.country === i.country;
        }).length,
      };
    })
    .uniqWith(isEqual)
    .value();

  return (
    <Pie
      {...{
        data: data,
        colorField: "country",
        angleField: "value",
        label: {
          type: "inner",
          autoRotate: false,
          offset: "-50%",
          content: function content(_ref) {
            if (_ref.percent > 0.1) {
              return `${_ref.country} \n ${_ref.value}`;
            }
          },
          style: {
            fontSize: 14,
            textAlign: "center",
          },
        },
        legend: { position: "top-left" },
        height: 260,
      }}
    />
  );
}

function GeolocationMap(props) {
  const { robots = [], ...rest } = props;
  const [searchText, setSearchText] = useState("");

  const handleSearch = () => {
    setSearchText(searchText);
  };

  const filterSWR = () => {
    if (searchText === "") {
      return robots;
    } else {
      return robots
        .map((item) =>
          (item.name &&
            item.name
              .toString()
              .toLowerCase()
              .includes(searchText.toLowerCase())) ||
          (item.customer &&
            item.customer
              .toString()
              .toLowerCase()
              .includes(searchText.toLowerCase())) ||
          (item.company &&
            item.company
              .toString()
              .toLowerCase()
              .includes(searchText.toLowerCase())) ||
          (item.location &&
            item.location
              .toString()
              .toLowerCase()
              .includes(searchText.toLowerCase()))
            ? item
            : null
        )
        .filter((item) => item);
    }
  };
  return (
    <Card
      {...rest}
      // extra={
      //   <Search
      //     placeholder="Search SWR"
      //     onSearch={() => {
      //       handleSearch();
      //     }}
      //     onChange={(e) => {
      //       setSearchText(e.target.value);
      //     }}
      //     enterButton
      //   />
      // }
    >
      <Card.Grid hoverable={false} style={{ padding: 12, width: "75%" }}>
        <WorldMap robots={filterSWR()}></WorldMap>
      </Card.Grid>
      <Card.Grid hoverable={false} style={{ padding: 12, width: "25%" }}>
        <DistributionChart robots={robots} />
      </Card.Grid>
    </Card>
  );
}

export default GeolocationMap;
